window.addEventListener("load", () => {
  const services = document.querySelectorAll(".service");

  for (let service of services) {
    let currBtn = service.querySelector(".service-toggle");
    let content = service.querySelector(".service-content");
    let title = service.querySelector(".service-header");
// Check if content has children
    if (content.children.length > 0) {

      title.addEventListener("click", () => {
        service?.classList.toggle("open");
        currBtn?.classList.toggle("open");
        content?.classList.toggle("open");
        title?.classList.toggle("open");
      });
  }
  }
});
